import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteGroup } from "../../api/group";
import Group from "../../models/group";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";

interface GroupDeleteModalProps {
  show: boolean;
  group?: Group;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const GroupDeleteModal: React.FC<GroupDeleteModalProps> = ({
  show,
  group,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = group
    ? `Está seguro de que quiere eliminar el grupo ${group.name}`
    : "";

  const onDeleteClick = async () => {
    if (group !== undefined) {
      setSubmitting(true);
      const groupStatus = await deleteGroup(group);

      if (groupStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (groupStatus.detail !== undefined) {
          message = groupStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default GroupDeleteModal;
